import React from 'react';
import Reflux from 'reflux';
import ReactDOM from 'react-dom';
import 'normalize.css';

import IngredientsStore from '~/stores/ingredients.js'
import QuantitiesStore from '~/stores/quantities.js'
import CategoriesStore from '~/stores/categories.js'
import CurrentRecipeStore from '~/stores/currentRecipe.js'

import App from './modules/App';

import './styles/main.styl';


if (module.hot) module.hot.accept();

// global stores
Reflux.initStore(IngredientsStore)
Reflux.initStore(QuantitiesStore)
Reflux.initStore(CategoriesStore)
Reflux.initStore(CurrentRecipeStore)


ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js